import { EditorState, RichUtils } from 'draft-js';

var removeBlockStyle = function removeBlockStyle(editorState) {
  var withoutBlockStyle = RichUtils.tryToRemoveBlockStyle(editorState);
  if (withoutBlockStyle) {
    return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
  }
  return editorState;
};

export default removeBlockStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-modifiers/es/removeBlockStyle.js
// module id = 251
// module chunks = 0